module.exports = __webpack_public_path__ + "static/media/LifeCalendar_cover.2d572b5f.png";